import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';

import { goalsUpdatedFailure, goalsUpdatedSuccess } from './goal.actions';

@Injectable({
  providedIn: 'root'
})
export class GoalsResponse {
  constructor(private actions$: Actions) {}

  public goalsUpdatedSuccess$ = this.actions$.pipe(ofType(goalsUpdatedSuccess));

  public goalsUpdatedFailure$ = this.actions$.pipe(ofType(goalsUpdatedFailure));
}
